import * as React from 'react';
const SvgArrowGlyph = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
        <path
            d="M13.58 12.5c.413-.853.8-1.493 1.16-1.92H3.08v-.84h11.66c-.36-.427-.747-1.067-1.16-1.92h.7c.84.973 1.72 1.693 2.64 2.16v.36c-.92.453-1.8 1.173-2.64 2.16h-.7z"
            fill="currentColor"
        />
    </svg>
);
export default SvgArrowGlyph;
